import {
  BookGymRoomThunk,
  FetchAllGymRoomsThunk,
  FetchMyGymRoomThunk,
  sendMedicalDeclarationThunk,
  updateGymRoomThunk,
  updateMedicalFormThunk,
  UploadMedicalCertificateThunk,
} from './GymActions';
import { GymState } from './GymTypes';
import { GYM_NAMESPACE } from './GymReducer';
import { useAppAction, useAppSelector } from '../hooks';

export function useGymSelector<T extends (state: GymState) => any>(
  selector: T
): ReturnType<T> {
  return useAppSelector((state) => selector(state[GYM_NAMESPACE]));
}

export const useMyGymRoom = () =>
  useGymSelector((state) => {
    return state.myGymRoom;
  });

export const useGymRooms = () =>
  useGymSelector((state) => {
    return state.gymRooms;
  });

export const useFetchMyGymRoom = () => useAppAction(FetchMyGymRoomThunk);

export const useFetchAllGymRooms = () => useAppAction(FetchAllGymRoomsThunk);

export const useBookGymRoom = () => useAppAction(BookGymRoomThunk);

export const useUpdateBookGymRoom = () => useAppAction(updateGymRoomThunk);

export const useSendMedicalDeclaration = () =>
  useAppAction(sendMedicalDeclarationThunk);

export const useUploadMedicalCertificate = () =>
  useAppAction(UploadMedicalCertificateThunk);

export const useUpdateMedicalForm = () => useAppAction(updateMedicalFormThunk);
